import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from '../../../services/common.service';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { DriverImportService } from 'src/app/services/driver-import.service';
import { DateFields, NameFields } from '../attr-mapping.constants';
import { CustomContentService } from 'src/app/services/custom-content.service';
import { DriverImportConfirmationComponent } from './driver-import-confirmation.component';
import { ImportDetailDialogComponent } from './import-detail-dialog.component';
import { HttpResponse } from '@angular/common/http';
import * as csv from 'csvtojson';

import {
  FieldDefinition,
  DropDownItem,
  RowDefinition,
  ColumnMapping,
  ImportConfigurationItem,
  ImportType,
  FileUploadConfig,
  Translation,
  FileMimeType,
  CsvMapping,
} from '../driver-import-interfaces';
import { FileUploaderComponent } from 'src/app/components/file-uploader/file-uploader.component';
@Component({
  selector: 'vrm-import-configuration-dialog',
  templateUrl: './import-configuration-dialog.component.html',
  styleUrls: ['./import-configuration-dialog.component.scss'],
})
export class ImportConfigurationDialogComponent implements OnInit {
  file: File;
  updateCaller: () => void;
  dialogTitle: string = this.translate.instant('DRIVER_IMPORT.importNewDriverData');
  titleDescription?: string;
  showProgress: boolean = false;
  errorMessage: string = '';
  onError: boolean = false;
  confirmBoxRef: MatDialogRef<DriverImportConfirmationComponent>;
  percentProgress = { value: 0 };
  showProgressBar: boolean = false;
  private companyColour = this.cService.userProfile ? '#' + this.cService.userProfile.HqColour : '';
  headerTextColour = 'white';
  actionBtnBgColour: string = this.companyColour;
  isLarge: boolean = false;
  uploadAvailable: boolean = false;
  selectedConfig: string = 'Current Configuration';
  newColumnName: string;

  importTypes: ImportType[] = [
    { name: this.translate.instant('DRIVER_IMPORT.newUpdateDrivers'), value: 'ALL_DRIVERS' },
    { name: this.translate.instant('DRIVER_IMPORT.allDrivers'), value: 'NEW_UPDATE_DRIVERS' },
    { name: this.translate.instant('DRIVER_IMPORT.deleteDrivers'), value: 'DELETE_DRIVERS' },
  ];

  headerBgColour: string = '#028ed3';
  dialogSettings: MatDialogConfig = { width: '600px', disableClose: true };
  hasHeaderRow: boolean = true;
  companyName: string;
  columnDefs: FieldDefinition[];
  config: ImportConfigurationItem;
  importConfigurations: ImportConfigurationItem[];
  skipRows: number = 0;
  fullNameFormat: string = 'firstMiddleLast';
  fileUploadConfig: FileUploadConfig = {
    mimeTypesAccepted: FileMimeType.CSV,
    data: null,
    preprocessor: {
      action: this.prepFileUpload.bind(this),
    },
  };
  sampleUploadConfig: FileUploadConfig = {
    mimeTypesAccepted: FileMimeType.CSV,
    data: null,
    preprocessor: {
      action: this.populateRows.bind(this),
    },
  };

  useSample: boolean = false;
  displayedColumns: string[] = ['originColumn', 'destinationColumn', 'delete'];
  showNewColumnTextBox: boolean;
  dropDownItemsOrigin: DropDownItem[];
  dropDownItemsDestination: DropDownItem[];
  dropDownItemsDateFormat: string[];
  dropDownItemsNameFormat: string[];
  missingFields: FieldDefinition[];
  translation: Translation;
  userId: number;
  rows: RowDefinition[];
  selectedField = new FormControl();
  columnKeys: string[];
  originalColumnKeys: string[];
  samples: string[];
  saveMapping: boolean = false;
  selectedImportType: string;
  modeUpload: boolean = true;
  fileContents: any[];
  sampleFile: File;

  @ViewChild(FileUploaderComponent) fileUploader!: FileUploaderComponent;
  constructor(
    private driverImportService: DriverImportService,
    private router: Router,
    private translate: TranslateService,
    private cContentService: CustomContentService,
    public cService: CommonService,
    public dialogRef: MatDialogRef<ImportConfigurationDialogComponent>,
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA)
    public data: { command: string; importConfigurations: ImportConfigurationItem[]; callBack: () => void }
  ) {
    this.columnKeys = [];
    this.rows = [];
    this.importConfigurations = data.importConfigurations;

    this.updateCaller = data.callBack;
    this.userId = this.cService.userProfile?.userId;
    this.companyName = this.cService.userProfile?.company;

    this.translate.get(['DRIVER_IMPORT']).subscribe({
      next: (translation) => {
        this.translation = translation.DRIVER_IMPORT;
      },
    });

    if (this.importConfigurations && this.importConfigurations.length > 0) {
      this.config = this.importConfigurations[0];
      this.hasHeaderRow = this.config.hasHeaders;
      this.selectedImportType = this.config.type;
      this.skipRows = this.config.skipRows;
    }
    if (data.command == 'editConfig') {
      this.dialogTitle = this.translation.editConfiguration;
      this.modeUpload = false;
      if (this.config) {
        this.getColumnDefs().then(() => {
          this.populateColumnsFromSavedMappings(this.config.columnMappings);
        });
      }
    }
  }

  checkDateField(fieldName: string): boolean {
    return DateFields.includes(fieldName);
  }
  checkNameField(fieldName: string): boolean {
    return NameFields.includes(fieldName);
  }
  addNewRow(): void {
    const newRow: RowDefinition = {
      destinationColumn: '',
      originColumn: '',
      dropDownItemsOrigin: this.dropDownItemsOrigin,
      dropDownItemsDestination: this.dropDownItemsDestination,
      dataType: 'string',
      dateFormat: '',
      nameFormat: '',
      allowedValues: [],
      formatOptions: [],
    };

    this.rows = [...this.rows, newRow];
  }
  addColumn(): void {
    if (this.newColumnName.trim()) {
      this.dropDownItemsOrigin.push({ name: this.newColumnName.trim(), value: this.newColumnName.trim() });
      this.dropDownItemsOrigin = this.dropDownItemsOrigin;
      this.showNewColumnTextBox = false;
    } else {
      console.error('Column name cannot be empty.');
    }
  }
  originColumnChange(e) {
    this.showNewColumnTextBox = true;
  }
  navigateToDriverImport() {
    this.router.navigate(['/driver-import']);
  }
  get destinationColumns() {
    return this.columnDefs;
  }

  getTemplateField(fieldKey: string) {
    return this.columnDefs.find((a) => a.fieldKey === fieldKey);
  }
  checkMissingRequiredMappings(mappings: ColumnMapping[]): boolean {
    this.missingFields = this.columnDefs
      .map((colDef) => {
        const field = mappings.find((d) => d.templateField === colDef.fieldKey);

        if (colDef.required && (!field || !field.csvColumn)) {
          return colDef;
        }
        return null;
      })
      .filter((colDef) => colDef !== null);

    return this.missingFields.length > 0;
  }

  closeConfirmBox() {
    this.confirmBoxRef.close();
    this.updateCaller();
  }
  closeConfirmBoxAndConfigBox() {
    this.confirmBoxRef.close();
    this.dialogRef.close(true);
    this.updateCaller();
  }

  populateColumnsFromSavedMappings(columnMappings: CsvMapping[]): void {
    this.rows = [];
    this.originalColumnKeys = [];
    if (Array.isArray(columnMappings) && columnMappings.length > 0) {
      this.generateFieldDropDowns(columnMappings);

      columnMappings.forEach((mapping) => {
        const templateField = this.getTemplateField(mapping.templateField);
        let dateFormat = '';
        let nameFormat = '';
        if (this.checkDateField(templateField.fieldKey)) {
          dateFormat = mapping.format;
        }
        if (this.checkNameField(templateField.fieldKey)) {
          nameFormat = mapping.format;
        }
        this.originalColumnKeys.push(mapping.csvColumn);

        this.rows.push({
          destinationColumn: templateField.fieldKey,
          originColumn: mapping.csvColumn || '',
          dropDownItemsOrigin: this.dropDownItemsOrigin,
          dropDownItemsDestination: this.dropDownItemsDestination,
          dataType: templateField?.type || 'string',
          dateFormat: dateFormat || '',
          nameFormat: nameFormat || '',
          allowedValues: [],
          formatOptions: templateField?.formatOptions || [],
        });
      });
    } else {
      console.error('Invalid mappingConfigurations:', columnMappings);
    }
  }

  private generateFieldDropDowns(columnMappings: ColumnMapping[]) {
    this.dropDownItemsOrigin = [];
    this.dropDownItemsDestination = [];
    this.dropDownItemsNameFormat = [];
    this.dropDownItemsDateFormat = [];

    columnMappings.forEach((mapping) => {
      this.dropDownItemsOrigin.push({ name: mapping.csvColumn, value: mapping.csvColumn });
    });

    this.columnDefs.forEach((d) => {
      this.dropDownItemsDestination.push({ name: d.fieldName, value: d.fieldKey });
    });
  }

  getColumnDefs() {
    return new Promise((resolve, reject) => {
      this.driverImportService.getAllColumnDefs(this.companyName).subscribe(
        (res) => {
          this.columnDefs = res.bodyResponse;
          return resolve(this.columnDefs);
        },
        (error) => {
          console.error('Error fetching column definitions:', error);
          reject();
        }
      );
    });
  }

  onSaveConfiguration(): void {
    const columnMappings: ColumnMapping[] = [];
    this.rows.every((col) => {
      const templateField = this.columnDefs.find((a) => a.fieldKey === col.destinationColumn);
      if (!templateField) {
        this.showSaveConfigurationMissingFieldsErrors();
        return false;
      }
      let format = '';
      if (this.checkDateField(templateField.fieldKey)) {
        format = col.dateFormat;
      } else if (this.checkNameField(templateField.fieldKey)) {
        format = col.nameFormat;
      }
      columnMappings.push({
        csvColumn: col.originColumn || '',
        templateField: templateField.fieldKey,
        format: format,
      });
      return true;
    });

    if (this.checkMissingRequiredMappings(columnMappings)) {
      this.showSaveConfigurationMissingFieldsErrors();
      return;
    }
    const payload: ImportConfigurationItem = {
      configId: this.config ? this.config.configId : '',
      companyId: this.companyName,
      createdAt: new Date().toISOString(),
      hasHeaders: this.hasHeaderRow,
      skipRows: this.skipRows,
      nameFormat: this.fullNameFormat,
      type: this.selectedImportType,
      columnMappings: columnMappings,
    };

    const saveObservable = this.config
      ? this.driverImportService.updateConfiguration(this.companyName, payload.configId, payload)
      : this.driverImportService.createConfiguration(this.companyName, payload);

    saveObservable.subscribe({
      next: (response) => {
        if (response.bodyResponse) {
          this.percentProgress.value = 0;
          this.updateCaller();
          this.showSuccessfulSave();
        }
      },
      error: (error) => {
        console.error('Error saving configuration:', error);
        this.showSaveConfigurationServerErrors(error.errorBody.bodyResponse);
      },
    });
  }
  private showSuccessfulSave() {
    const dialogSettings = this.dialogSettings;
    dialogSettings.data = {
      title: this.translate.instant('DRIVER_IMPORT.fileMappingSaved'),
      message: this.translate.instant('DRIVER_IMPORT.mappingSavedMessage'),
      actionText: this.translate.instant('DRIVER_IMPORT.actionTextContinue'),
      action: this.closeConfirmBoxAndConfigBox.bind(this),
      isWarning: false,
      warningMessage: '',
    };
    this.confirmBoxRef = this.cContentService.dialog.open(DriverImportConfirmationComponent, dialogSettings);
    this.confirmBoxRef.afterClosed().subscribe(() => {
      this.uploadAvailable = true;
    });
  }

  private showSaveConfigurationMissingFieldsErrors() {
    const dialogSettings = this.dialogSettings;
    dialogSettings.data = {
      title: this.translation.missingRequiredFields,
      message: this.translation.missingRequiredFieldsMsg,
      missingFields: this.missingFields,
      actionText: this.translation.actionTextReturn,
      action: this.closeConfirmBox.bind(this),
      isWarning: true,
      warningMessage: this.translation.warningImportance,
    };
    this.confirmBoxRef = this.cContentService.dialog.open(DriverImportConfirmationComponent, dialogSettings);
    this.confirmBoxRef.afterClosed().subscribe(() => {
      this.fileUploader.cancelFile();
    });
  }

  private showSaveConfigurationServerErrors(response) {
    const message = response.message;
    const dialogSettings = this.dialogSettings;
    const errors = [];

    if (response.errorDetail) {
      response.errorDetail.forEach((d) => {
        const code = d.code.replaceAll('.', '_');
        const errorTxt = this.translation[code];
        errors.push(errorTxt);
      });
    }
    dialogSettings.data = {
      title: this.translation.saveConfigurationFailed,
      message: message,
      errors: errors,
      actionText: this.translation.actionTextReturn,
      action: this.closeConfirmBox.bind(this),
      isWarning: true,
      warningMessage: this.translation.warningServerError,
    };

    this.confirmBoxRef = this.cContentService.dialog.open(DriverImportConfirmationComponent, dialogSettings);
    this.confirmBoxRef.afterClosed().subscribe(() => {
      this.fileUploader.cancelFile();
    });
  }

  private showImportFileUploadError(response) {
    const message = this.translate.instant('DRIVER_IMPORT.jobCreationFailed');
    const errors = [];
    if (response.errorDetail) {
      response.errorDetail.forEach((d) => {
        const code = d.code.replaceAll('.', '_');
        const errorTxt = this.translation[code];
        errors.push(errorTxt);
      });
    }
    this.showProgress = false;
    const dialogSettings = this.dialogSettings;
    dialogSettings.data = {
      title: this.translate.instant('DRIVER_IMPORT.errorCreatingImportJob'),
      message: message,
      errors: errors,
      actionText: this.translate.instant('DRIVER_IMPORT.actionTextReturn'),
      action: this.closeConfirmBox.bind(this),
      isWarning: true,
      warningMessage: 'Error: ',
      showReturn: true,
    };

    this.confirmBoxRef = this.cContentService.dialog.open(DriverImportConfirmationComponent, dialogSettings);
    this.confirmBoxRef.afterClosed().subscribe(() => {
      this.fileUploader.cancelFile();
    });
  }

  private showImportFileTypeError(response) {
    const message = this.translate.instant('DRIVER_IMPORT.unSupportedFileTypeError');
    const errors = [];
    if (response.errorDetail) {
      response.errorDetail.forEach((d) => {
        const code = d.code.replaceAll('.', '_');
        const errorTxt = this.translation[code];
        errors.push(errorTxt);
      });
    }
    this.showProgress = false;
    const dialogSettings = this.dialogSettings;
    dialogSettings.data = {
      title: this.translate.instant('DRIVER_IMPORT.saveConfigurationFailed'),
      message: message,
      errors: errors,
      actionText: this.translate.instant('DRIVER_IMPORT.actionTextReturn'),
      action: this.closeConfirmBox.bind(this),
      isWarning: true,
      warningMessage: 'Error: ',
      showReturn: true,
    };

    this.confirmBoxRef = this.cContentService.dialog.open(DriverImportConfirmationComponent, dialogSettings);
    this.confirmBoxRef.afterClosed().subscribe(() => {
      this.fileUploader.cancelFile();
    });
  }

  updateImportHistory() {
    this.updateCaller();
  }
  deleteColumn(row: RowDefinition) {
    this.rows = this.rows.filter((c) => c !== row);
  }
  async ngOnInit(): Promise<void> {
    await this.getColumnDefs();
  }

  async parseCsv(file: File): Promise<void> {
    if (!file) {
      console.error('No file to process.');
      return;
    }

    const fileType = file.type.split(';')[0].trim();

    try {
      this.fileContents = await new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onload = async (event) => {
          try {
            if (fileType === FileMimeType.CSV) {
              const csvContent = event.target?.result as string;
              resolve(await csv().fromString(csvContent));
            } else {
              reject(new Error('Unsupported file format.'));
            }
          } catch (error) {
            reject(error);
          }
        };

        reader.onerror = (error) => reject(error);

        if (fileType === FileMimeType.CSV) {
          reader.readAsText(file);
        } else {
          console.error('Unsupported file format.');
        }
      });
    } catch (error) {
      console.error('Error processing file:', error);
    }
  }

  rePopulateRows() {
    this.populateRows(null);
  }

  async populateRows(file) {
    if (file) {
      this.sampleFile = file;
    }
    if (this.sampleFile) {
      await this.parseCsv(this.sampleFile);
      this.columnKeys = Object.keys(this.fileContents[0]);
    } else {
      if (this.originalColumnKeys) {
        this.columnKeys = this.originalColumnKeys;
      }
    }

    this.rows = [];

    if (!this.hasHeaderRow) {
      this.columnKeys = this.columnKeys.map((_, i) => `Column${i + 1} `);
    }

    this.dropDownItemsOrigin = this.columnKeys.map((column) => ({
      name: column,
      value: column,
    }));

    this.dropDownItemsDestination = this.columnDefs.map((d) => ({
      name: d.fieldName,
      value: d.fieldKey,
    }));

    if (this.columnKeys) {
      this.rows = this.columnKeys.map((column, i) => ({
        destinationColumn: '',
        dropDownItemsOrigin: this.dropDownItemsOrigin,
        dataType: 'string',
        originColumn: column,
        description: '',
        dropDownItemsDestination: this.dropDownItemsDestination,
        dateFormat: '',
        nameFormat: '',
        allowedValues: [],
        formatOptions: [],
      }));
    }
  }

  unSupportedFileTypeError(evt) {
    if (this.modeUpload) {
      this.showImportFileUploadError(evt);
    } else {
      this.showImportFileTypeError(evt);
    }
  }

  prepFileUpload(file) {
    this.file = file;
    this.uploadAvailable = true;
  }

  formatOptions(fieldKey: string) {
    let def = this.columnDefs.find((d) => d.fieldKey === fieldKey);
    return def.formatOptions;
  }
  uploadDrivers() {
    this.showProgress = true;
    this.uploadAvailable = false;
    this.driverImportService
      .createImportJob(
        this.companyName,
        this.userId,
        this.selectedImportType,
        this.config.configId,
        false,
        [],
        '',
        this.file
      )
      .subscribe({
        next: (event) => {
          this.percentProgress.value = 0;
          if (event instanceof HttpResponse) {
            this.percentProgress.value = 100;
            this.dialogRef.close(false);
            this.showProgress = false;
            this.dialog.open(ImportDetailDialogComponent, {
              width: '70%',
              data: { details: event.body.bodyResponse, callBack: this.updateImportHistory.bind(this) },
            });
          } else {
            if (event.type === 3) {
              if (event.loadeds >= this.file.size) {
                this.percentProgress.value = 100;
              }
              this.percentProgress.value = (event.loaded / this.file.size) * 100;
            }
          }
        },
        error: (error) => {
          this.showImportFileUploadError(error.errorBody.bodyResponse);
          this.uploadAvailable = false;
        },
        complete: () => {
          this.showProgress = false;
          this.uploadAvailable = false;
          this.file = undefined;
        },
      });
  }

  completeUpload() {
    this.closeConfirmBox();
    this.dialogRef.close(false);
  }

  dialogClosed(): void {
    this.dialogRef.close(false);
  }
  onRowUpdated(updatedRow: RowDefinition) {
    const index = this.rows.findIndex((row) => row.originColumn === updatedRow.originColumn);
    if (index !== -1) {
      this.rows[index] = { ...updatedRow };
    }
  }
  onRowDeleted(rowToDelete: RowDefinition) {
    this.rows = this.rows.filter((row) => row !== rowToDelete);
  }
  onAddNewRow() {
    this.addNewRow();
  }
  onAddNewColumn() {
    this.showNewColumnTextBox = true;
  }
}
